import React, { Component } from 'react'
import { Row, Col, Select, List, Button, Modal, Spin, Input, Card, Popconfirm } from 'antd'
import { api, app, config } from "../../app"
import utils from "../../utils"
import command from "./command"

const Option = Select.Option

/**
 * 判断审核
 * @param audit
 * @returns {string}
 */
function checkAudit(audit) {
    switch (audit) {
        case "0":
            return "未审核"
        case "1":
            return "已通过"
        case "2":
            return "不通过"
    }
}

/**
 * 检查按钮
 * @param item
 * @returns {{text: string, disabled: boolean}}
 */
function checkBtn(item) {
    const obj = {
        text: "参加并支付",
        disabled: false,
    }
    if (item.pay_status === "1") {
        obj.disabled = true
        obj.text = "已报名"
    } else if (item.pay_status === "2") {
        obj.disabled = true
        obj.text = "已退款"
    } else if (item.allly_status === 1) {
        obj.disabled = true
        obj.text = "已结束报名"
    } else if (parseInt(item.join_number) >= parseInt(item.train_number)) {
        obj.disabled = true
        obj.text = "名额已满"
    } else if (parseInt(item.train_price) === 0) {
        obj.text = "报名参加"
    }
    return obj
}

class NTrainList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            detailInfo: {},
            trainList: [],
            class_id: "",
            search_val: "",
        }
    }

    /**
     * 关闭详情
     */
    closeDetailModal = () => {
        this.setData({ detail_visible: false, detail_loading: false, detailInfo: {} })
    }


    /**
     * 打开详情
     */
    openDetailModal = async (id) => {
        await this.setData({ detail_visible: true, detail_loading: true })
        const params = {
            id,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.TraintDetails, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = {}
        }
        this.setData({ detailInfo: data, detail_loading: false })
    }

    componentDidMount() {
        this._isMounted = true
        this.dataSource()
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    /**
     * 设置值
     * @param obj
     */
    setData = (obj) => app.setStateSync(this, obj)

    /**
     * 数据加载
     * @returns {Promise<void>}
     */
    dataSource = async () => {
        await this.setData({ data_loading: true })
        const { class_id, search_val } = this.state,
            params = {
                class_id,
                search_val,
                indexno: app.getData("indexno"),
                account: app.getData("account"),
            }
        let { flag, data, msg, total } = await app.post(api.TrainList2, params)
        if (flag === 1) {
            this.setData({ data_loading: false, trainList: utils.addArrayKey(data), total: parseInt(total) })
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 筛选条件变更
     * @param e
     */
    handleFilterChange = async (e) => {
        await this.setData({ class_id: e, page: 1 })
        await this.dataSource()
    }

    /**
     * 搜索
     * @param search_val
     */
    handleSearch = async (search_val) => {
        await this.setData({ search_val, page: 1 })
        await this.dataSource()
    }

    /**
     * 支付
     **/
    // handlePay = (orders_no) => {
    //     Modal.confirm({
    //         title: '确认报名此培训吗？',
    //         onOk: async () => {
    //             let flag = await command.trainPay(orders_no)
    //             if (flag) {
    //                 await this.dataSource()
    //             }
    //         }
    //     })
    // }

    /**
     * 支付
     **/
    handlePay = async (orders_no) => {
        let flag = await command.trainPay2(orders_no)
        if (flag) {
            await this.dataSource()
        }
    }
    /**
     * 重新报名支付
     **/
    handleRePay = async (id) => {
        app.alert('正在提交', 'loading', '35%', 0)
        const params = {
            id,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, msg } = await app.post(api.TAddUserApply, params)
        app.alertDestroy()
        if (flag === 1) {
            app.alert('提交成功', 'success')
            await this.dataSource()
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 不再显示设置
     * @param id
     * @returns {Promise<void>}
     */
    handleNotShow = async (id) => {
        let flag = await command.hideMessageOrTrain(id, 'train')
        if (flag) {
            await this.dataSource()
        }
    }

    render() {
        const { loading, detail_visible, detailInfo, trainList, detail_loading } = this.state,
            detail_btn = checkBtn(detailInfo),
            review_node = (
                <Row className="item">
                    <Col span={4} className="title">审核情况：</Col>
                    <Col span={19} offset={1}>
                        {/* <Card bodyStyle={{ padding: 10 }} className="item-card" title="队管理员审核">
                            {
                                detailInfo.team_header_indexno ?
                                    (
                                        <div>
                                            <div>审核人：{detailInfo.team_header_indexno}</div>
                                            <div>审核状态：{checkAudit(detailInfo.team_header_audit)}</div>
                                            <div>审核时间：{detailInfo.team_header_time || "无"}</div>
                                            {detailInfo.team_header_audit === "2" ?
                                                <div>不通过原因：{detailInfo.detail}</div> : null}
                                        </div>
                                    ) : "暂无审核"
                            }
                        </Card> */}
                        {detailInfo.object !== '4' ?
                            (<Card bodyStyle={{ padding: 10 }} className="item-card" title="管理员审核">
                                {
                                    detailInfo.admin_indexno ?
                                        (
                                            <div>
                                                <div>审核人：{detailInfo.admin_indexno}</div>
                                                <div>审核状态：{checkAudit(detailInfo.admin_audit)}</div>
                                                <div>审核时间：{detailInfo.admin_time || "无"}</div>
                                                {detailInfo.admin_audit === "2" ?
                                                    <div>不通过原因：{detailInfo.detail}</div> : null}
                                            </div>
                                        ) : "暂无审核"
                                }
                            </Card>) : null
                        }
                        <Card bodyStyle={{ padding: 10 }} className="item-card" title="发布人审核">
                            {
                                detailInfo.publish_indexno ?
                                    (
                                        <div>
                                            <div>审核人：{detailInfo.publish_indexno}</div>
                                            <div>审核状态：{checkAudit(detailInfo.publish_audit)}</div>
                                            <div>审核时间：{detailInfo.publish_time || "无"}</div>
                                            {detailInfo.publish_audit === "2" ?
                                                <div>不通过原因：{detailInfo.detail}</div> : null}
                                        </div>
                                    ) : "暂无审核"
                            }
                        </Card>
                    </Col>
                </Row>
            ),
            infos = []
        if (detailInfo.is_class === '1') {
            infos.push(
                (<Row key="1" className="item">
                    <Col span={4} className="title">培训周期：</Col>
                    <Col span={19}
                        offset={1}>{detailInfo.train_day}天</Col>
                </Row>)
            )
            let cla = detailInfo.class
            if (cla) {
                infos.push(
                    (<Row key="2" className="item">
                        <Col span={4} className="title">班级名称：</Col>
                        <Col span={19}
                            offset={1}>{cla.class_name}</Col>
                    </Row>),
                    (<Row key="3" className="item">
                        <Col span={4} className="title">培训时间：</Col>
                        <Col span={19}
                            offset={1}>{cla.startdate + ' ~ ' + cla.endate}</Col>
                    </Row>),
                    (<Row key="4" className="item">
                        <Col span={4} className="title">培训地点：</Col>
                        <Col span={19}
                            offset={1}>{cla.train_site || "无记录"}</Col>
                    </Row>),
                    (<Row key="5" className="item">
                        <Col span={4} className="title">培训状态：</Col>
                        <Col span={19} offset={1}>
                            {
                                cla.train_status === '1' ? '进行中' : (cla.train_status === '2' ? '已完成' : '未开始')
                            }
                        </Col>
                    </Row>)
                )
            }
        } else {
            infos.push(
                (<Row key="1" className="item">
                    <Col span={4} className="title">培训时间：</Col>
                    <Col span={19}
                        offset={1}>{detailInfo.startdate + ' ~ ' + detailInfo.endate}</Col>
                </Row>),
                (<Row key="2" className="item">
                    <Col span={4} className="title">培训地点：</Col>
                    <Col span={19} offset={1}>{detailInfo.train_site || '暂无'}</Col>
                </Row>),
                (<Row key="3" className="item">
                    <Col span={4} className="title">培训状态：</Col>
                    <Col span={19} offset={1}>
                        {
                            detailInfo.train_status === '1' ? '进行中' : (detailInfo.train_status === '2' ? '已完成' : '未开始')
                        }
                    </Col>
                </Row>)
            )
        }
        return (
            <div className="n-page notice-train-list">
                <div className="page-title">培训任务</div>
                <div className="page-content">
                    <Row className="page-top">
                        <Col span={24}>
                            <Select placeholder="筛选" className="filter" onChange={this.handleFilterChange}>
                                <Option value="0">全部培训</Option>
                                <Option value="1">内部培训</Option>
                                <Option value="2">外部培训</Option>
                                <Option value="3">特定培训</Option>
                            </Select>
                            <Input.Search placeholder="搜索" onSearch={this.handleSearch}
                                style={{ width: 200, marginLeft: 20 }} />
                        </Col>
                    </Row>
                    <div className="items" id="train-list">
                        <List
                            locale={{
                                emptyText: "暂无培训信息"
                            }}
                            loading={loading}
                            dataSource={trainList}
                            renderItem={(item, index) => {
                                let cla = "无", startdate = item.startdate
                                switch (item.class_id) {
                                    case "1":
                                        cla = "内部培训"
                                        break
                                    case "2":
                                        cla = "外部培训"
                                        break
                                    case "3":
                                        cla = "特定培训"
                                        break
                                }
                                let btnObj = checkBtn(item)
                                return (
                                    <List.Item key={index}>
                                        <div className="train-img">
                                            <img alt="" src={config.imgUrl + item.browse_images} />
                                        </div>
                                        <div className="train-info">
                                            <Row type="flex" align="middle">
                                                <Col span={10} className="ti-title">培训课程：{item.trainame}</Col>
                                                <Col span={14} className="ti-content">培训类型：{cla}</Col>
                                            </Row>
                                            <Row>
                                                <Col span={10} className="ti-title">培训师：{item.train_teacher}</Col>
                                                <Col span={14} className="ti-content">培训价格：<span
                                                    style={{ c19or: "#FF0000" }}>{item.train_price}</span> 元</Col>
                                            </Row>
                                            <Row>
                                                <Col span={10} className="ti-title">可获得技能：{item.train_ppe || "无"}</Col>
                                                <Col span={14} className="ti-content">已报名人数：<span
                                                    style={{ c19or: "#3399CC" }}>{item.join_number}</span> / {item.train_number}人</Col>
                                            </Row>
                                            <Row>
                                                <Col span={24} className="ti-title">
                                                    {
                                                        item.is_class === '1' ?
                                                            (`培训周期：${item.train_day}天`) : ('开始培训日期：' + startdate)
                                                    }
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col span={10} className="ti-title">报名截止日期：{item.apply_time}</Col>
                                                <Col span={14} className="ti-content">
                                                    <Button onClick={() => this.openDetailModal(item.id)}>培训详情</Button>
                                                    <Button disabled={btnObj.disabled} className="btn-end"
                                                        type="primary" style={{ marginLeft: 15 }}
                                                        onClick={() => this.handlePay(item.orders_no)}>{btnObj.text}</Button>
                                                    {item.renew_status === 1 ? (
                                                        <Button type="primary" onClick={() => this.handleRePay(item.train_id)} style={{ marginLeft: 15 }}>重新报名</Button>
                                                    ) : null}
                                                    {
                                                        item.pay_status !== '1' ? (
                                                            <Popconfirm title="确定不再显示吗？" onConfirm={() => this.handleNotShow(item.id)}>
                                                                <Button type="danger" icon="delete" style={{ marginLeft: 15 }}>不再显示</Button>
                                                            </Popconfirm>
                                                        ) : null
                                                    }
                                                </Col>
                                            </Row>
                                        </div>
                                    </List.Item>
                                )
                            }}
                        />
                    </div>
                    {/*培训详情对话框*/}
                    <Modal
                        visible={detail_visible}
                        onCancel={this.closeDetailModal}
                        width={800}
                        title={<div style={{ textAlign: "center" }}>培训详情</div>}
                        className="notice-train-list-detail"
                        footer={
                            <div style={{ textAlign: "center" }}>
                                <Button type="primary" style={{ marginRight: 20 }}
                                    disabled={detail_btn.disabled}
                                    onClick={() => this.handlePay(detailInfo.orders_no)}>{detail_btn.text}</Button>
                                <Button onClick={() => this.closeDetailModal()}>取消</Button>
                            </div>
                        }
                    >
                        {
                            detail_loading ? (<div style={{ textAlign: 'center' }}><Spin size="large" /></div>) : (
                                <div className="items">
                                    <div className="braft-output-content"
                                        dangerouslySetInnerHTML={{ __html: detailInfo.train_content }}
                                        style={{ padding: '20px 0' }} />
                                    <Row className="item">
                                        <Col span={4} className="title">培训课程：</Col>
                                        <Col span={19} offset={1}>{detailInfo.trainame}</Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4} className="title">培训师：</Col>
                                        <Col span={19} offset={1}>{detailInfo.train_teacher}</Col>
                                    </Row>
                                    {infos}
                                    <Row className="item">
                                        <Col span={4} className="title">报名截止时间：</Col>
                                        <Col span={19} offset={1}>{detailInfo.apply_time}</Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4} className="title">培训价格：</Col>
                                        <Col span={19}
                                            offset={1}>{parseFloat(detailInfo.train_price).toFixed(2)} 元</Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4} className="title">培训人数：</Col>
                                        <Col span={19} offset={1}>{detailInfo.train_number}</Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4} className="title">已报名人数：</Col>
                                        <Col span={19} offset={1}>{detailInfo.join_number}</Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4} className="title">培训级别：</Col>
                                        <Col span={19} offset={1}>
                                            {detailInfo.object === "1" ? "全国" : (detailInfo.object === "2" ? "省级" : (detailInfo.object === "3" ? "市级" : "队伍"))}
                                        </Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4} className="title">培训装备：</Col>
                                        <Col span={19} offset={1}>{detailInfo.train_equip || '无'}</Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4} className="title">培训技能：</Col>
                                        <Col span={19} offset={1}>{detailInfo.train_ppe || '无'}</Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4} className="title">培训时长：</Col>
                                        <Col span={19}
                                            offset={1}>{detailInfo.train_hour ? detailInfo.train_hour + '时' : '暂无'}</Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4} className="title">培训评语：</Col>
                                        <Col span={19} offset={1}>{detailInfo.train_comment || '暂无'}</Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4} className="title">是否支付：</Col>
                                        <Col span={19}
                                            offset={1}>{detailInfo.pay_status === "1" ? "已支付" : (detailInfo.pay_status === "2" ? "已退款" : "未支付")}</Col>
                                    </Row>
                                    <Row className="item">
                                        <Col span={4} className="title">备注：</Col>
                                        <Col span={19} offset={1}>{detailInfo.detail || '无'}</Col>
                                    </Row>
                                    {detailInfo.pay_status === "1" ? review_node : null}
                                    <Row className="item">
                                        <Col>
                                            {
                                                (detailInfo.details_images || []).map((img, index) => {
                                                    return (<img key={index} src={config.imgUrl + img} alt=""
                                                        className="d-img" />)
                                                })
                                            }
                                        </Col>
                                    </Row>
                                </div>
                            )
                        }
                    </Modal>
                </div>
            </div>
        )
    }
}

export default NTrainList



// WEBPACK FOOTER //
// ./src/routes/notice/NTrainList.jsx